import * as UserMutationTypes from '../store/modules/user/user.types.js';

import firebase from 'firebase';
import { firebaseConfig } from '../config';
import { store } from '../store/store.js';

const REFRESH_BEFORE_TIME = 15 * 60 * 1000; // 15min in milliseconds

class FirebaseService{
  constructor(firebase){
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    firebase.analytics();

    this.firebase = firebase;
    this.setupObservers();
    this.oneTimeHandlers = {};
    this.eventHandlers = {};
  }

  async setupObservers(){
    this.firebase.auth().onAuthStateChanged((user) => this.onAuthStateChanged(user));
  }

  get currentUser(){
    return this.firebase.auth().currentUser;
  }

  /**
   * Returns an Id token for the current user.
   */
  async getIdTokenResult(forceRefresh=false){
    if(!this.firebase.auth().currentUser) return "";
    return this.firebase.auth().currentUser.getIdTokenResult(forceRefresh);
  }
  async login(email, password){
    try{
      store.commit(UserMutationTypes.LOGIN);
      await this.firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
      const result = await this.firebase.auth().signInWithEmailAndPassword(email, password);
      // Success will be handled in onAuthStateChaanged
    }catch(error){
      store.dispatch(UserMutationTypes.LOGIN_FAILURE, { errorMessage: error.message });
    }
  }
  async logout(){
    try{
      await this.firebase.auth().signOut();
      // Success will be handled in onAuthStateChaanged
    }catch(e){
      console.error("Failed to Logout", e);
    }
  }
  async onAuthStateChanged(user){
    console.log("[onAuthStateChanged] user", user);
    if(user){
      await store.dispatch(UserMutationTypes.LOGIN_SUCCESS, { user });

      // checks if current token is about to expire
      // this is for the case the user loads the page less than 5 min
      // before token expiration
      // the token would expire before the first interval of token check
      await this.checkTokenExpiration();
    }else{
      console.log("[onAuthStateChanged] There is No User");
      store.dispatch(UserMutationTypes.LOGOUT);
    }
    this.callEventHandlers('onAuthStateChanged', user);
  }

  callEventHandlers(event, ...args){
    console.log("Calling Event Handlers for ", event);
    
    const oneTimeEvents = this.oneTimeHandlers[event];
    if(Array.isArray(oneTimeEvents)){
      console.log("oneTimeEvents ", oneTimeEvents.length);
      for(const callback of oneTimeEvents){
        oneTimeEvents.splice(callback, 1);
        callback.apply(null, args);
      }
    }
    
    const eventHandlers = this.eventHandlers[event];
    if(Array.isArray(eventHandlers)){
      console.log("eventHandlers ", eventHandlers.length);
      for(const callback of eventHandlers){
        callback.apply(null, args);
      }
    }
  }

  once(event, callback){
    console.log("Adding Event Handler for ", event);
    if(Array.isArray(this.oneTimeHandlers[event])){
      this.oneTimeHandlers[event].push(callback);
    }else{
      this.oneTimeHandlers[event] = [callback];
    }
  }
  on(event, callback){
    if(Array.isArray(this.eventHandlers[event])){
      this.eventHandlers[event].push(callback);
    }else{
      this.eventHandlers[event] = [callback];
    }
  }
  removeListener(event, callback){
    if(Array.isArray(this.eventHandlers[event])){
      this.eventHandlers[event].splice(this.eventHandlers.indexOf(callback),1);
    }
  }

  async checkTokenExpiration() {
    if(!this.currentUser) return;

    const now = Date.now();
    const timeToExpire = store.getters.loginExpirationTime - now;
    console.log("time to expire in ms: ", timeToExpire);
    if(timeToExpire < REFRESH_BEFORE_TIME) {
      await this.refreshToken();
    }
  }

  async refreshToken() {
    try {
      console.log("Refreshing token...")
      const tokenResult = await this.getIdTokenResult(true);
      console.log("Token result: ", tokenResult);
      store.dispatch(UserMutationTypes.REFRESH_TOKEN_SUCCESS, { tokenResult });
    } catch (error) {
      console.error("Failed to refresh token:", error);
    }
  }
}


export default new FirebaseService(firebase);


// WEBPACK FOOTER //
// ./src/services/firebase.service.js